import $ from 'jquery'
import Page from "./components/ICalendarFeedsPage"

export default function init() {
    new Page().init($('.iCalendarFeedsPage'))
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/index.js